/**
 * HSL Lighten
 *
 * @returns {string}
 */
export default function hslLighten(hslColor, amount) {
  let hsl = hslColor.match('hsl\\((\\d+),\\s*([\\d.]+)%,\\s*([\\d.]+)%\\)')

  hsl[3] = parseFloat(hsl[3]);

  let maxAmount = 100 - hsl[3];
  let addAmount = maxAmount * amount / 100;
  hsl[3] = hsl[3] + addAmount;

  return `hsl(${hsl[1]}, ${hsl[2]}%, ${hsl[3]}%)`
}
